// extracted by mini-css-extract-plugin
module.exports = {"sub-copy":"SubCopy_sub-copy__8K5h1","sub-copy__copy":"SubCopy_sub-copy__copy__4HL_Y"};